import "./App.css";

import toast, { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <div>
      <Toaster />
      </div>
    </>
  );
}

export default App;
